// extracted by mini-css-extract-plugin
module.exports = {"unit":"8px","questionText":"text-question__questionText____qtAtI","hintText":"text-question__hintText____2r2ZC","input":"text-question__input____3flQm"};